import { useMemo } from 'react'
import { Button } from '@/atoms/Button'
import { ParagraphMD } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useTranslate } from '@/utils/translate/translate-client'
import { TorchApplicationTypes, useTorchApplication } from '../../components/TorchApplicationContext'
import { buildSrcUrl } from './agreementUtils'

interface Props {
  disabled: boolean
}

export const FilmmakerAgreementButton = ({ disabled }: Props) => {
  const { t } = useTranslate('common')
  const { id, data, type } = useTorchApplication()

  const { jotFormSrc, success } = useMemo(() => {
    const jotFormUrl = buildSrcUrl({ data, id, type: type || TorchApplicationTypes.Concept })

    return {
      jotFormSrc: jotFormUrl || paths.guild.create.index,
      success: !!jotFormUrl,
    }
  }, [data, id, type])

  return (
    <>
      {success ? (
        <a href={disabled ? '#' : jotFormSrc}>
          <Button variant="oxide" disabled={disabled}>
            {t('signAgreement', 'Sign Agreement')}
          </Button>
        </a>
      ) : (
        <ParagraphMD>
          {t('anErrorOccurredContactTheEmailBelow', 'An error occurred, please contact the email address below')}
        </ParagraphMD>
      )}
    </>
  )
}
